import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import "../../assets/styles/local/TaskDelete.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const TaskDelete = (props) => {
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
  }, []);

  return (
    <>
      <Modal
        id="asc"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="text-center">
          <div>
            <p className="firstHead pt- m-0">
              {" "}
              {t("This data will be removed from the system")}{" "}
            </p>
            <p className="firstHead m-0"> {t("and cannot be undone.")}</p>
            <p className="proceed pt-2">
              {t("Do you want to proceed?")}
            </p>
          </div>

          <div className="d-flex justify-content-center flex-wrap gap-4 pt-5">
            <div className="btnNoDiv">
              <button className="btnNo p-2" onClick={props.onHide}>
                {t("No")}
              </button>
            </div>

            <div className="btnYesDiv">
              {/* <button onClick={props.handleDelete}>yes</button> */}
              <button className="btnYes p-2" onClick={props.handleDelete}>
                {t("Yes")}
                {props.loading === true && (
                  <div
                    className="spinner-border spinner-border-sm ms-2"
                    role="status"
                  ></div>
                )}
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {/* <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

            <Modal show={show} onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal> */}
    </>
  );
};

export default TaskDelete;
